import I18n from '@/services/i18n/i18n'
const t = I18n.getInstance().getFixedNamespaceT('settings')

export const flowTypes = {
  SELF: 'SELF',
  HELP: 'HELP'
}

export const steps = {
  [flowTypes.SELF]: [
    {
      header: t('self.chooseCategory.header'),
      description: t('self.chooseCategory.description'),
      routeName: 'chooseCategory',
      bgClass: 'bg-blue'
    },
    {
      header: t('self.chooseTemplate.header'),
      description: t('self.chooseTemplate.description'),
      routeName: 'chooseTemplate',
      bgClass: 'bg-white'
    },
    {
      header: t('self.form.header'),
      subHeader: t('self.form.subHeader'),
      routeName: 'selfSignUp',
      bgClass: 'bg-blue'
    }
  ],
  [flowTypes.HELP]: [
    {
      header: t('help.websiteEnquiry.header'),
      routeName: 'websiteEnquiry',
      bgClass: 'bg-blue'
    },
    {
      header: t('help.choosePackage.header'),
      routeName: 'choosePackage',
      bgClass: 'bg-blue'
    },
    // {
    //   header: t('help.summary.header'),
    //   routeName: 'helpSummary',
    //   bgClass: 'bg-blue'
    // },
    {
      header: t('help.form.header'),
      routeName: 'helpSignUp',
      bgClass: 'bg-blue'
    },
    {
      header: t('help.confirmation.header'),
      routeName: 'helpConfirmation',
      skipStep: true,
      bgClass: 'bg-white'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/config.js